"use strict";
var thumbs = document.getElementById("thumbs");
var image = document.getElementById("largeImg");
thumbs.addEventListener("click", function(e) {
    e.preventDefault();
    var link = e.target.closest(".list-item__link");
    if (link) image.src = link.href;
});

//# sourceMappingURL=index.c228e09a.js.map
